// Tasks 24474 / 24469 - SLA definitions and per-customer assignment.

export const SLA_PROFILE_LIST = "SLA_PROFILE_LIST";
export const SLA_PROFILE_LIST_SUCCESS = "SLA_PROFILE_LIST_SUCCESS";
export const SLA_PROFILE_LIST_FAILURE = "SLA_PROFILE_LIST_FAILURE";

export const SLA_PROFILE_DATA = "SLA_PROFILE_DATA";
export const SLA_PROFILE_DATA_SUCCESS = "SLA_PROFILE_DATA_SUCCESS";
export const SLA_PROFILE_DATA_FAILURE = "SLA_PROFILE_DATA_FAILURE";

export const SLA_PROFILE_CREATE = "SLA_PROFILE_CREATE";
export const SLA_PROFILE_CREATE_SUCCESS = "SLA_PROFILE_CREATE_SUCCESS";
export const SLA_PROFILE_CREATE_FAILURE = "SLA_PROFILE_CREATE_FAILURE";

export const SLA_PROFILE_UPDATE = "SLA_PROFILE_UPDATE";
export const SLA_PROFILE_UPDATE_SUCCESS = "SLA_PROFILE_UPDATE_SUCCESS";
export const SLA_PROFILE_UPDATE_FAILURE = "SLA_PROFILE_UPDATE_FAILURE";

export const SLA_PROFILE_DELETE = "SLA_PROFILE_DELETE";
export const SLA_PROFILE_DELETE_SUCCESS = "SLA_PROFILE_DELETE_SUCCESS";
export const SLA_PROFILE_DELETE_FAILURE = "SLA_PROFILE_DELETE_FAILURE";

export const SLA_METRIC_CREATE = "SLA_METRIC_CREATE";
export const SLA_METRIC_CREATE_SUCCESS = "SLA_METRIC_CREATE_SUCCESS";
export const SLA_METRIC_CREATE_FAILURE = "SLA_METRIC_CREATE_FAILURE";

export const SLA_METRIC_UPDATE = "SLA_METRIC_UPDATE";
export const SLA_METRIC_UPDATE_SUCCESS = "SLA_METRIC_UPDATE_SUCCESS";
export const SLA_METRIC_UPDATE_FAILURE = "SLA_METRIC_UPDATE_FAILURE";

export const SLA_METRIC_DELETE = "SLA_METRIC_DELETE";
export const SLA_METRIC_DELETE_SUCCESS = "SLA_METRIC_DELETE_SUCCESS";
export const SLA_METRIC_DELETE_FAILURE = "SLA_METRIC_DELETE_FAILURE";

export const CUSTOMER_SLA_LIST = "CUSTOMER_SLA_LIST";
export const CUSTOMER_SLA_LIST_SUCCESS = "CUSTOMER_SLA_LIST_SUCCESS";
export const CUSTOMER_SLA_LIST_FAILURE = "CUSTOMER_SLA_LIST_FAILURE";

export const CUSTOMER_SLA_ACTIVE = "CUSTOMER_SLA_ACTIVE";
export const CUSTOMER_SLA_ACTIVE_SUCCESS = "CUSTOMER_SLA_ACTIVE_SUCCESS";
export const CUSTOMER_SLA_ACTIVE_FAILURE = "CUSTOMER_SLA_ACTIVE_FAILURE";

export const CUSTOMER_SLA_ASSIGN = "CUSTOMER_SLA_ASSIGN";
export const CUSTOMER_SLA_ASSIGN_SUCCESS = "CUSTOMER_SLA_ASSIGN_SUCCESS";
export const CUSTOMER_SLA_ASSIGN_FAILURE = "CUSTOMER_SLA_ASSIGN_FAILURE";

export const CUSTOMER_SLA_DELETE = "CUSTOMER_SLA_DELETE";
export const CUSTOMER_SLA_DELETE_SUCCESS = "CUSTOMER_SLA_DELETE_SUCCESS";
export const CUSTOMER_SLA_DELETE_FAILURE = "CUSTOMER_SLA_DELETE_FAILURE";
